/* eslint-disable camelcase */
angular.module('app.ui.form.ctrls').controller('ReferFriendController', [
  'InviteFriendApi',
  '$location',
  '$scope',
  'sharedProperties',
  'userService',
  '$translate',
  '$cookies',
  'logger',
  function controller(
    InviteFriendApi,
    $location,
    $scope,
    sharedProperties,
    userService,
    $translate,
    $cookies,
    logger
  ) {
    async function initializeData() {
      vm.user = await userService.getUser()
      vm.populateCode(vm.user.id)
    }

    initializeData()

    var friendNameAndEmail

    let vm = this

    vm.textTocopy = angular.element('.refer-message').text()

    vm.notify = (type, message) => {
      switch (type) {
        case 'info':
          logger.log(message)
          break
        case 'success':
          logger.logSuccess(message)
          break
        case 'warning':
          logger.logWarning(message)
          break
        case 'error':
          logger.logError(message)
          break
        default:
          break
      }
    }

    vm.editorOptions = {
      extraPlugins: 'colorbutton',
    }
    vm.curLawyer = {
      user: {
        first_Name: $cookies.firstName,
      },
    }
    $translate.use('en')
    vm.referralCode = ''
    vm.friendsList = []
    friendNameAndEmail = {
      name: '',
      email: '',
    }
    vm.friendsList.push(friendNameAndEmail)
    vm.hideDropDown = () => {
      vm.showClass = ''
    }

    vm.showClass = ''
    vm.showDropDown = () => {
      if (vm.showClass === '') {
        vm.showClass = 'show'
      } else {
        vm.showClass = ''
      }
    }

    vm.copySuccess = () => {
      vm.notify('success', 'Message successfully copied to clipboard')
    }

    vm.copyFail = error => {
      vm.notify('error', 'Unable to copy.')
    }

    vm.showClass = ''
    vm.showDropDown = () => {
      if (vm.showClass === '') {
        vm.showClass = 'show'
      } else {
        vm.showClass = ''
      }
    }

    vm.getEmailText = async refer => {
      const {data, status} = await InviteFriendApi.getInviteFriendsEmail()

      if (status === 440) $location.url('/signin')
      vm.referEmail.emailText = stringReplaceAll(
        data.versions[0].html_content,
        '<%-referralCode%>',
        `${process.env.PUBLIC_URL}/sign-up/${refer}`
      )
      vm.referEmail.emailText = stringReplaceAll(
        vm.referEmail.emailText,
        '{{publicURL}}',
        process.env.PUBLIC_URL
      )

      vm.referEmail.emailText = stringReplaceAll(
        vm.referEmail.emailText,
        '{{referredPerson.name}}',
        '[name]'
      )

      vm.referEmail.emailText = stringReplaceAll(
        vm.referEmail.emailText,
        '{{user.firstName}}',
        vm.user.firstName
      )
      vm.referEmail.emailText = stringReplaceAll(
        vm.referEmail.emailText,
        '{{ user.lastName}}',
        vm.user.lastName
      )
      vm.referEmail.emailText = stringReplaceAll(
        vm.referEmail.emailText,
        '{{user.referralCode}}',
        vm.referralCode
      )
      $scope.$apply()
    }

    vm.referEmail = {
      friendsName: [],
      friendsEmail: [],
      subject: '',
      frCount: 0,
      emailText: '',
      friends: [],
    }
    vm.isFriendsListFilled = () => {
      var friendsListSize
      var index
      var k
      var reference
      friendsListSize = vm.friendsList.length
      for (
        // eslint-disable-next-line no-multi-assign
        index = k = 0, reference = friendsListSize;
        reference >= 0 ? k < reference : k > reference;
        index = reference >= 0 ? ++k : --k
      ) {
        if (!vm.friendsList[index].email) {
          return false
        }
      }

      return true
    }

    vm.trackReferFriend = friendsList => {
      try {
        analytics.track('Refering Friends', {
          referral_code: vm.referralCode,
          friends_list: friendsList,
        })
      } catch (error) {
        console.error('Refer A Friend', error)
      }
    }

    vm.sendReferEmail = async () => {
      vm.referEmail.friends = vm.friendsList
      vm.referEmail.emailText = vm.referEmail.emailText.replace(
        '[yourFirstName]',
        vm.user.firstName
      )
      vm.referEmail.emailText = vm.referEmail.emailText.replace(
        '[yourLastName]',
        vm.user.lastName
      )

      const {status} = await InviteFriendApi.sendReferralEmails(
        vm.user.id,
        vm.friendsList,
        false
      )

      if (status !== 201)
        return vm.notify(
          'error',
          'There has been an error in sending your emails. Please try again'
        )
      if (status === 201) {
        return logger.notify('success', 'Email(s) have been sent successfully.')
      }

      vm.trackReferFriend(vm.friendsList)
    }

    vm.anotherFriend = () => {
      friendNameAndEmail = {
        name: '',
        email: '',
      }
      if (vm.friendsList.length < 5) {
        vm.friendsList.push(friendNameAndEmail)
      }
    }

    vm.removeFriend = removedFriend => {
      var itemToBeRemovedIndex
      itemToBeRemovedIndex = vm.friendsList.indexOf(removedFriend)
      vm.friendsList.splice(itemToBeRemovedIndex, 1)
    }

    vm.logOut = () => {
      sharedProperties.logOut()
    }

    vm.populateCode = data => {
      vm.referralCode = data
      var lexstepReferUrl = `${process.env.PUBLIC_URL}/sign-up/${vm.referralCode}`
      var encodedReferUrl = encodeURIComponent(lexstepReferUrl)
      vm.shareLink =
        'https://www.facebook.com/sharer/sharer.php?u=' +
        encodedReferUrl +
        '&amp;src=sdkpreparse'
      vm.dataLink = lexstepReferUrl
      vm.getEmailText(vm.referralCode)
      vm.textTocopy = lexstepReferUrl
      vm.referEmail.subject =
        'Invitation from your friend ' +
        vm.curLawyer.user.first_Name +
        ' ' +
        vm.curLawyer.user.last_Name
      $scope.$applyAsync()
    }

    vm.referFriend = () => {
      $location.url('/refer-friend')
    }

    vm.firmsAndJobs = () => {
      $location.url('/opportunities')
    }

    vm.loadProfile = () => {
      $location.url('/user-profile')
    }

    vm.AppliedJobs = () => {
      $location.url('/connections')
    }
  },
])
const stringReplaceAll = function(target, search, replacement) {
  return target.replace(new RegExp(search, 'g'), replacement)
}



// WEBPACK FOOTER //
// ./scripts/refer-friend/refer-friend.ctrl.js